export const ethAddress = 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export const suiAddress = '2::sui::SUI';
export const tonAddress = 'EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c';

export const etherscanHostByCode = {
  ETH: 'https://etherscan.com',
  BSC: 'https://bscscan.com',
  MATIC: 'https://polygonscan.com',
  OP: 'https://optimistic.etherscan.io',
  CAVAX: 'https://snowtrace.io',
  ARBI: 'https://arbiscan.io',
  FTM: 'https://ftmscan.com',
} as Record<string, string>;

export const getTokenAddress = (poolCode: string) => {
  const address = {
    eth: ethAddress,
    sui: suiAddress,
    ton: tonAddress,
  };
  // 目前只有sui需要单独处理
  const specialCode = ['SUI', 'TON'];
  if (!specialCode.includes(poolCode)) {
    return address.eth;
  }
  return address[`${poolCode.toLowerCase()}`];
};
